export const VCList = [
    {
        "ventureCapitalFund": 212,
        "mainInstitution": 212,
        "foundedYear": 2012,
        "city": "Luxembourg",
        "hq": "Luxembourg",
        "summary": "A VC fund that invests in early-stage B2B technology startups and is Türkiye's first.",
        "details": "Founded 12 years ago, 212 is Türkiye’s first institutional venture capital fund. It supports innovative, growth-stage technology companies in Türkiye, Central and Eastern Europe, the Middle East, and within diaspora communities through an established global network. 212's strategy focuses on fostering the international growth of successful B2B technology startups with proven product-market fit. Guided by a vision to invest in strong teams, 212 has established a presence in Istanbul, London, Doha, and San Francisco, and operates with an experienced team. With its first two funds—$30 million in 2012 and €50 million in 2019—the firm has invested in early-stage technology startups, creating over $2 billion in portfolio value. In 2024, 212 plans to move forward with its third fund, targeting €70 million.",
        "sectoralPreferences": "6,5,10,24",
        "geographicalPreferences": "Türkiye, Central and Eastern Europe, MENA, Turkish Diaspora",
        "fundSize": "€ 70 M",
        "ticketSize": "$1.5 M-5 M ",
        "investmentStrategyText": "Pre-Seed",
        "website": "https://212.vc/",
        "contactUs": "info@212.vc",
        "contactUsEmail": "info@212.vc",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": 1,
        "investmentStrategy": [
            1
        ],
        "logo":"/images/logos/212.jpg"
    },
    {
        "ventureCapitalFund": "212 NexT",
        "mainInstitution": 212,
        "foundedYear": 2023,
        "city": "Lüksemburg",
        "hq": "Luxembourg",
        "summary": "A VC fund that invests in startups developing disruptive technologies in advanced materials.",
        "details": "212 NexT is a venture capital fund focused on disruptive innovations in advanced materials, targeting Seed to Series A stage investments globally. The fund concentrates on start-ups pioneering breakthroughs in chemicals, biomaterials, nullomaterials, catalysts, energy efficiency, recycling, and AI-driven materials discovery. 212 NexT leverages its industrial investor network and proprietary connections to identify technologies that address strategic challenges, while working to expand its portfolio in the field of advanced materials. The fund aims to reach a target size of €30 million.\n\n\n\n\n\n",
        "sectoralPreferences": "12",
        "geographicalPreferences": "Global",
        "fundSize": "$30 M ",
        "ticketSize": "$500 K-1 M",
        "investmentStrategyText": "Seed and Series A",
        "website": "https://212next.fund/",
        "contactUs": "info@212next.fund",
        "contactUsEmail": "info@212next.fund",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": 2,
        "investmentStrategy": [
            6
        ],
        "logo":"/images/logos/212next.jpg"
    },
    {
        "ventureCapitalFund": "Simya VCIF-NEO Portfolio Management Inc.",
        "mainInstitution": 212,
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "An international accelerator VC fund focused on early-stage startups.",
        "details": "Simya VC is an international acceleration fund focused on early-stage startups with global high-growth potential, particularly those with B2B business models. Beyond providing capital, Simya VC offers strategic support to help Turkish startups scale internationally, leveraging its extensive network to drive global sales and market expansion. The fund also has an exclusive partnership with the Alchemist Accelerator, enhancing its ability to propel portfolio companies to global success. Fund I has a total size of $7 million and fund II has $10 million.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$10 M ",
        "ticketSize": "$350 K-750K",
        "investmentStrategyText": "Pre-seed, Seed",
        "website": "https://simya.vc/en/home/",
        "contactUs": "         Zeynep Şener  ",
        "contactUsEmail": "zeynep@simya.vc",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2
        ],
        "logo":"/images/logos/simya.jpg"
    },
    {
        "ventureCapitalFund": "ACT Venture Partners",
        "mainInstitution": "ACT Venture Partners Coöperatief U.A.",
        "foundedYear": 2015,
        "city": "Amsterdam",
        "hq": "The Netherlands",
        "summary": "A VC fund manager that invests in early stage deep tech start-ups.",
        "details": "ACT Venture Partners is a venture capital fund manager focused on deep tech investments. Operating under the EU Alternative Investment Fund Managers Directive, it specializes in backing early-stage, purpose-driven Turkish and European tech founders who are working on groundbreaking innovations. Its investment strategy spans quantum technologies, health tech, sustainability, AI, and satellite technology—fields it believes will shape the future.\nIts approach goes beyond just funding; it actively works to mitigate both technology and market risks by leveraging regulatory changes and government support for R&D. It invests at the seed stage and continues supporting its portfolio companies through Series A and B. By tapping into a global network of universities, tech transfer offices, and R&D grant programs, it ensures a steady pipeline of high-potential deals. ACT Venture Partners is passionate about helping visionary founders scale their innovations globally and make a lasting impact.\n",
        "sectoralPreferences": "22,17,1,21",
        "geographicalPreferences": "Türkiye, Europe",
        "fundSize": "€ 50 M",
        "ticketSize": "€ 500 K-1.5 M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.actvp.vc",
        "contactUs": "Erhan Ziya Kılıçözlü",
        "contactUsEmail": "info@actvp.vc",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": 4,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/act.jpg"
    },
    {
        "ventureCapitalFund": "Actera Partners III L.P.",
        "mainInstitution": "Actera Group",
        "foundedYear": 2019,
        "city": "Jersey",
        "hq": "United Kingdom",
        "summary": "A PE fund that focuses on growth capital and buyout investments in emerging companies.",
        "details": "Actera Partners III L.P.  is a private equity fund based in Jersey. The fund's investor base includes prominent global investment institutions.  The fund makes growth capital and buyout investments across a wide range of industries and sectors.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$ 700 M",
        "ticketSize": "$ 40-75 M",
        "investmentStrategyText": "Series A and above",
        "website": "https://www.acteragroup.com",
        "contactUs": "Aaron Kernoghan",
        "contactUsEmail": "info@acteragroup.com",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            4
        ],
        "logo":"/images/logos/actera.jpg"
    },
    {
        "ventureCapitalFund": "First Renewable Energy VCIF",
        "mainInstitution": "Ak Asset Management",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in renewable energy projects that are either operational or have completed all necessary permits.\n\n\n\n\n\n",
        "details": "The First Renewable Energy Fund, open to investments from PPS funds, institutional companies, and qualified individual investors, focuses on renewable energy projects that are either operational or have secured all necessary permits.",
        "sectoralPreferences": "17",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺339 M",
        "ticketSize": "$500 K-1 M",
        "investmentStrategyText": "Tohum, Seri A",
        "website": "https://www.akportfoy.com.tr/tr/fon/BYG-ak-portfoy-yonetimi-a.s.-birinci-yenilenebilir-enerji-girisim-sermayesi-yatirim-fonu",
        "contactUs": "Cansu Tuğul Karayel",
        "contactUsEmail": "ckarayel@akportfoy.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":"/images/logos/akportfoy.jpg"
    },
    {
        "ventureCapitalFund": "First Technology VCIF",
        "mainInstitution": "Ak Asset Management",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in early-stage startups in AI, healthtech, cybersecurity, fintech and gaming.",
        "details": "Since 2023, First Technology Fund has invested in 4 startups specializing in artificial intelligence, cybersecurity and gaming, while continuing to explore similar verticals for potential investments. ",
        "sectoralPreferences": "1,10,2,22,18,23,6,4",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺51 M",
        "ticketSize": "$500 K-1 M",
        "investmentStrategyText": "Tohum, Seri A",
        "website": "https://www.akportfoy.com.tr/tr/fon/AK4-ak-portfoy-yonetimi-as-birinci-teknoloji-girisim-sermayesi-yatirim-fonu",
        "contactUs": "Cansu Tuğul Karayel",
        "contactUsEmail": "ckarayel@akportfoy.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":"/images/logos/akportfoy.jpg"
    },
    {
        "ventureCapitalFund": "Third VCIF",
        "mainInstitution": "Ak Asset Management",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in technology and innovation-oriented SMEs in the growth stage with high export potential.",
        "details": "The Third Technology Fund is open to investment from PPS Funds, institutional companies, and qualified individual investors, offering long-term capital to growth-stage, technology, and innovation-focused medium-sized companies with significant export potential. The fund aims to deliver high returns to investors in the medium to long term by supporting the market capitalization growth of companies within its portfolio.\n\n\n\n\n\n",
        "sectoralPreferences": "0,6,8,22,12,14,23",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺234 M",
        "ticketSize": "$500 K-1 M",
        "investmentStrategyText": "Tohum, Seri A",
        "website": "https://www.akportfoy.com.tr/tr/fon/IUG-ak-portfoy-yonetimi-a.s.-ucuncu-girisim-sermayesi-yatirim-fonu",
        "contactUs": "Cansu Tuğul Karayel",
        "contactUsEmail": "ckarayel@akportfoy.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":"/images/logos/akportfoy.jpg"
    },
    {
        "ventureCapitalFund": "Startupfon Opportunity VCIF",
        "mainInstitution": "Aktif Asset Management",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in sector agnostic scaleups.",
        "details": "Startupfon Opportunity VC Fund, established in collaboration with Aktifbank, has a target size of 600 million TL and focuses on acquiring shares in growth-stage technology companies through secondary market transactions. By purchasing stakes from existing shareholders, the fund aims to provide new capital to these ventures while also accelerating exit timelines. Reflecting a commitment to supporting innovative companies as they scale and succeed in the market, the fund targets investments in globally competitive startups at Series A and B stages, acquiring shares from internal investors at a discounted valuation of 20-60%.\n",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 600 M",
        "ticketSize": "₺ 40-50 M",
        "investmentStrategyText": "Seed, Series A, Series B",
        "website": "https://www.startupfon.com",
        "contactUs": "Gülsüm Çıracı",
        "contactUsEmail": "gulsum@startupfon.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "APY Ventures VCIF",
        "mainInstitution": "Albaraka Asset Management Inc.",
        "foundedYear": 2020,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund serving as the umbrella brand for venture capital investment funds established by Albaraka Asset Management Inc., actively investing in early-stage technology startups.",
        "details": "APY Ventures is the umbrella brand for venture capital investment funds established by Albaraka Asset Management Inc., actively investing in entrepreneurs. The brand encompasses several venture capital funds tailored to meet the specific needs of both entrepreneurs and investors. The objective of APY Ventures is to facilitate connections between entrepreneurs and investors, creating a framework that aims to support all parties involved and provide tailored solutions to meet the diverse needs of the ecosystem.\nIn October 2024, six active Venture Capital Investment Funds operate under APY Ventures: the Start-up VC Fund, Informatics Valley VC Fund, Fintech VC Fund, Ostim VC Fund, T3 VC Fund, and the Next-Gen Technology VC Fund. With a total fund size exceeding 1.37 billion TRY (approximately 40 million USD), APY Ventures has invested in 60 companies.The team, led by Fund Manager Mustafa Keçeli and Vice President Doğukan Çetin, focuses on sustainable, long-term growth by collaborating closely with entrepreneurs. The fund focuses on sustainable, long-term growth by collaborating closely with entrepreneurs. Investment amounts range from 3.4 million TRY to 51.4 million TRY.\n\n\n\n\n\n\n\n\n\n\n",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺1.4 M",
        "ticketSize": "₺8.6M -68.9M",
        "investmentStrategyText": "Pre-seed, Seed, Pre-Series A, Series A",
        "website": "https://www.apyventures.com/",
        "contactUs": "Doğukan Çetin",
        "contactUsEmail": "dogukan.cetin@apyventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/apy.jpg"
    },
    {
        "ventureCapitalFund": "Start-up VCIF",
        "mainInstitution": "Albaraka Asset Management Inc.",
        "foundedYear": 2020,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that is Türkiye’s first venture capital investment fund listed on Borsa Istanbul, supporting innovative technological startups from the early stages and aiming to expand its portfolio to 32 ventures by 2029.",
        "details": "The Start-up Venture Capital Investment Fund is the first venture capital investment fund listed on Borsa Istanbul in Türkiye. It aims to support innovative technology ventures starting from the early stages. With a fund size of 356 million TL, it has invested in 17 ventures across sectors such as fintech, gaming, software, robotics, and digital marketing. In addition to providing finullcial support to ventures from pre-seed to growth stages, it also offers mentorship and collaboration opportunities.\nPositioned as a leader in the industry with over 800 qualified investors, Start-up VCIF aims to expand its portfolio to 32 ventures by 2029. The fund's average investment size is around 5 million TL, prioritizing projects that integrate industry with technology. With a focus on digital transformation and innovation-driven growth, it continues its journey with the mission of contributing to the entrepreneurial ecosystem and supporting companies that develop innovative solutions aligned with digital transformation.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺356 M",
        "ticketSize": "₺3.4M -51.4M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.apyventures.com/startup-gsyf",
        "contactUs": "Doğukan Çetin",
        "contactUsEmail": "dogukan.cetin@apyventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/apy.jpg"
    },
    {
        "ventureCapitalFund": "Bilişim Vadisi VCIF",
        "mainInstitution": "Albaraka Asset Management Inc.",
        "foundedYear": 2020,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that is the first publicly supported venture capital fund in Türkiye, aimed at strengthening the technology and innovation ecosystem, investing in ventures with global growth potential in sectors such as deep technology, mobility, alternative energy, gaming, and cybersecurity.\n\n\n\n\n",
        "details": "The Bilişim Vadisi Venture Capital Investment Fund was established in 2020 to strengthen Türkiye’s technology and innovation ecosystem. The fund focuses on sectors such as mobility, alternative energy, gaming, cybersecurity, and agricultural technologies, investing in ventures at pre-seed, seed, Pre-Series A, and Series A stages. Targeting startups that have achieved product-market fit, begun generating revenue, and possess global growth potential, the fund provides investments ranging from USD 100,000 to USD 1.5 million.\nFounded through a partnership between Vakıf Katılım, Albaraka Türk, and Bilişim Vadisi with an initial capital of USD 14 million, the fund has grown to a size of USD 22.5 million as of October 2024. To date, Bilişim Vadisi VCIF has invested in 40 ventures and aims to reach 60. As Türkiye’s first publicly supported VCIF, it stands out by offering not only finullcial backing but also collaboration opportunities, thereby expanding the entrepreneurial ecosystem. With its transparent structure, independent audits, and efficient management processes, the fund aims to contribute to Türkiye’s technological independence and enhance its competitiveness on a global scale.\n",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺776.1 M",
        "ticketSize": "₺8.6M -51.4M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.apyventures.com/bilisim-vadisi-gsyf",
        "contactUs": "Doğukan Çetin",
        "contactUsEmail": "dogukan.cetin@apyventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/apy.jpg"
    },
    {
        "ventureCapitalFund": "Fintech VCIF",
        "mainInstitution": "Albaraka Asset Management Inc.",
        "foundedYear": 2019,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund dedicated to investing in innovative ventures within the finullcial technology sector, aiming to drive digital transformation and create sustainable value in the fintech ecosystem.",
        "details": "Albaraka Portfolio Management Inc. Fintech Venture Capital Investment Fund (Albaraka Fintech VCIF) was established in 2019 to invest in innovative ventures within the finullcial technology sector. The fund focuses on fintech startups and technology-driven companies that provide products and services to finullcial institutions. By supporting early-stage and growth-potential fintech ventures, it contributes to the development of the industry in areas such as digital transformation, payment systems, blockchain, credit, and insurance technologies. Its mission is to accelerate the growth of startups while creating sustainable value within the finullcial technologies ecosystem.\n\nCurrently managing a fund size of 156 million TL, Albaraka Fintech VCIF has invested in 9 different ventures to date and continues to diversify its portfolio. While aiming to deliver strong finullcial returns to its investors, the fund also plays a leading role in facilitating exits for startups through sales, mergers, and public offerings. Looking ahead, it plans to expand its portfolio by supporting more innovative projects in Türkiye and on a global scale within the fintech sector.\n\n",
        "sectoralPreferences": "5",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺156 M",
        "ticketSize": "₺8.6M -51.4M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.apyventures.com/fintech-gsyf",
        "contactUs": "Doğukan Çetin",
        "contactUsEmail": "dogukan.cetin@apyventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/apy.jpg"
    },
    {
        "ventureCapitalFund": "Ostim VCIF",
        "mainInstitution": "Albaraka Asset Management Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund focused on the OSTİM ecosystem, investing in technology-driven industrial ventures and supporting domestic and national production.",
        "details": "The OSTİM Venture Capital Investment Fund is a 100 million TL fund established to invest in technology-focused companies with high growth potential. Concentrating on Ankara and the OSTİM ecosystem, it supports ventures particularly in sectors such as industrial and manufacturing technologies, robotics, renewable energy, and industrial software. To date, it has provided 40 million TL in investments, delivering capital and corporate guidance to 8 companies offering innovative solutions in the hardtech space. Leveraging the expertise of OSTİM and Albaraka, the fund not only offers finullcial resources but also digital transformation support to enhance scalability and competitiveness for its portfolio companies. Focusing on growth-stage ventures, OSTİM VCIF aims to promote the development of domestic and national technologies. Its future goals include increasing the total number of investments to 15 and the total investment size to 75 million TL. While supporting innovative and value-added production, the fund plans to deliver high returns to its investors through successful exit strategies. OSTİM VCIF is committed to contributing to Türkiye's technology-driven industrial infrastructure and positioning the OSTİM ecosystem as a leader in entrepreneurial innovation.\n",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺100 M",
        "ticketSize": "₺8.6M - 51.4M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.apyventures.com/ostim-gsyf",
        "contactUs": "Doğukan Çetin",
        "contactUsEmail": "dogukan.cetin@apyventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/apy.jpg"
    },
    {
        "ventureCapitalFund": "T3 VCIF",
        "mainInstitution": "Albaraka Asset Management Inc.",
        "foundedYear": 2024,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund managed by the Türkiye Technology Team(T3) Foundation, aimed at enhancing Türkiye's technological independence by providing finullcial and strategic support to national technology ventures.",
        "details": "Albaraka Portfolio Management Inc. T3 Venture Capital Investment Fund was established in May 2024 under the management of the Türkiye Technology Team Foundation (T3 Foundation). The fund's strategic goal is to enhance Türkiye's technological independence and contribute to the growth of national technology ventures. Operating in line with the National Technology Initiative, T3 VCIF not only provides finullcial support to high-potential technology startups but also helps them refine their business models and expand into international markets.\nUp until October 2024, managing a fund size of 33 million TL, T3 VCIF has so far invested in one venture, focusing on startups that develop innovative and competitive technology solutions. Beyond finullcing, the fund offers strategic guidance, development support, and mentorship to help these startups achieve robust growth in both national and global markets.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺33 M",
        "ticketSize": "₺5.1M -17.2M",
        "investmentStrategyText": "Pre-seed, Seed",
        "website": "https://www.apyventures.com/t3-gsyf",
        "contactUs": "Doğukan Çetin",
        "contactUsEmail": "dogukan.cetin@apyventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2
        ],
        "logo":"/images/logos/apy.jpg"
    },
    {
        "ventureCapitalFund": "Next-Generation Technology VCIF",
        "mainInstitution": "Albaraka Asset Management Inc.",
        "foundedYear": 2024,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund aiming to contribute to the digital ecosystem by supporting innovative startups developing future technologies at early stages and focusing on backing projects with the potential for global success. ",
        "details": "The Next-Generation Technology Venture Capital Investment Fund (VCIF), established by Albaraka Portfolio Management Inc., is an Ankara-based fund aimed at providing early-stage support to innovative startups developing the technologies of the future. Without distinction between software and hardware, the fund focuses on B2B and B2C ventures in sectors such as agriculture, green energy, cybersecurity, gaming, and mobile applications.\nThe fund aims to raise a total of 1 billion TL between 2024 and 2026, allocating 40% of this amount for follow-on investments in existing portfolio companies. It invests between USD 250,000 and USD 2 million in ventures ranging from pre-seed and seed stages to Series C. Backed by investors, technology entrepreneurs, and strategic partners, the fund is committed to accelerating the digital transformation of industries and supporting projects with the potential to achieve global success.\nWith the goal of investing in 20 new technology ventures, the Next-Generation Technology VCIF aims to support the digital ecosystem and contribute to the development of technology entrepreneurship.\n\n\n\n\n\n",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺1 B",
        "ticketSize": "₺8.6M -68.9M",
        "investmentStrategyText": "Pre-seed, Seed, Pre-Series A, Series A",
        "website": "-",
        "contactUs": "Doğukan Çetin",
        "contactUsEmail": "dogukan.cetin@apyventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/apy.jpg"
    },
    {
        "ventureCapitalFund": "Startupfon Seed VCIF",
        "mainInstitution": "Arz Real Estate and Venture Capital Asset Management Inc.",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in early-stage B2B, Industry 4, Web 3, AI and FinTech startups.",
        "details": "The Startupfon Seed Venture Capital Fund (Tohum GSYF) was established in September 2023 in partnership with Arz Portföy and Startupfon, aiming to invest in early-stage entrepreneurs in Türkiye. The fund focuses on startups in Türkiye with global market aspirations, primarily targeting early seed and seed-stage ventures in sectors such as B2B, Industry 4.0, Web3-AI, and Fintech. With a target size of 500 million TL, the Startupfon Seed VC Fund seeks to provide essential early-stage finullcing and foster innovation within the startup ecosystem.\n",
        "sectoralPreferences": "2,1,5",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 500 M",
        "ticketSize": "₺ 5-10 M",
        "investmentStrategyText": "Pre-seed, Seed",
        "website": "https://www.startupfon.com",
        "contactUs": "Gülsüm Çıracı",
        "contactUsEmail": "gulsum@startupfon.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2
        ],
        "logo":"/images/logos/arz.jpg"
    },
    {
        "ventureCapitalFund": "Fourth VCIF",
        "mainInstitution": "Arz Real Estate and Venture Capital Asset Management Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in early-stage artificial intelligence, healthTech, gaming, FinTech, MarketingTech, human resources tech startups.",
        "details": "Arz AMC 4th VC fund, which is carried out in strategic partnership with Bilişim Vadisi, started to make active investments in 2023 and invested in a total of 13 ventures.  The fund, which has invested in artificial intelligence, health technologies, fintech, marketing technologies, human resources technologies, gaming sectors, is sector agnostic and invests on a participation basis.",
        "sectoralPreferences": "1,22,4,5,24,7",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 500 M",
        "ticketSize": "₺2.5M -4 M ",
        "investmentStrategyText": "Seed, Pre-Seed",
        "website": "https://arzportfoy.com/",
        "contactUs": "Seda Kaşhan",
        "contactUsEmail": "seda.kashan@arzportfoy.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            1
        ],
        "logo":"/images/logos/arz.jpg"
    },
    {
        "ventureCapitalFund": "Technopark Istanbul High Technology VCIF",
        "mainInstitution": "Arz Real Estate and Venture Capital Portfolio Management Inc. ",
        "foundedYear": 2023,
        "city": "Istanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in early-stage startups in the field of antennas, biotechnology, energy, life sciences, advanced materials, optronics-mechatronics & sensors, defense, cybersecurity, transportation, and AI.",
        "details": "The High Technology Fund, with 11 investor partners, most of which are leading defence industries in Türkiye, operates in the focus areas of Teknopark Istanbul, including antenna, biotechnology, energy, life sciences, advanced materials, optronics-mechatronics & sensors, defense, cyber security, transportation, and artificial intelligence. The fund focuses on investing in early-stage startups in Türkiye that have developed prototypes in these high-tech areas. Beyond providing finullcial capital, the High Technology Fund offers startups access to smart capital through strategic partnerships with its investor network and opportunities in the defense industry. With a focus on early-stage investments, the fund has a total commitment size of 323.5 million TL and typically makes minority equity investments of 15-20%, with an average investment amount of $250K.",
        "sectoralPreferences": "1,22,22,18,12,12,11,9,10,14",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 323.5 M ",
        "ticketSize": "₺ 1M - 8.5 M ",
        "investmentStrategyText": "Pre-Seed, Seed",
        "website": "-",
        "contactUs": "Ahmet Akif Demirbaş",
        "contactUsEmail": "ademirbas@teknoparkistanbul.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 2,
        "investmentStrategy": [
            1,
            2
        ],
        "logo":"/images/logos/arz.jpg"
    },
    {
        "ventureCapitalFund": "Boğaziçi Ventures Growth I",
        "mainInstitution": "BV Portfolio Management Inc. ",
        "foundedYear": 2015,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "AVC fund that invests in Turkish technology startups focused on global growth.",
        "details": "Boğaziçi Ventures is a venture capital fund that invests in technology-oriented startups. Founded in 2015, Boğaziçi Ventures focuses on technology companies with high growth potential, particularly in Türkiye and its surrounding regions. Its portfolio includes innovative startups operating in fields such as artificial intelligence, fintech, gaming, software, and digital health. The fund follows growth-oriented strategies in its investments, providing entrepreneurs not only with capital support but also with experience, network, and mentorship services. Boğaziçi Ventures invests in both early-stage and growth-stage companies, aiming to enhance these ventures' competitiveness in global markets.\n\n\n",
        "sectoralPreferences": "1,4,5,23,7,22,2",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$ 35 M",
        "ticketSize": "$ 520 K",
        "investmentStrategyText": "Pre-Seed,  Seed, Series A",
        "website": "https://www.bogaziciventures.com/en",
        "contactUs": "Buğra Öklen",
        "contactUsEmail": "bugra@bogaziciventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            1,
            2,
            3
        ],
        "logo":"/images/logos/bogazici.jpg"
    },
    {
        "ventureCapitalFund": "Boğaziçi Ventures Growth II",
        "mainInstitution": "BV Portfolio Management Inc. ",
        "foundedYear": 2015,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "AVC fund that focuses on sector-agnostic high potential AI-enabled software businesses.",
        "details": "BVG II focuses on sector-agnostic, high-potential AI-enabled software businesses. It actively seeks Türkiye-based B2C and B2B startups with strong performance metrics and the potential to scale globally through an omni-channel digital marketing strategy.\n\n\n\n\n\n",
        "sectoralPreferences": "1,4,5,23,7,22,2",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$ 50 M",
        "ticketSize": "$ 1M-2 M",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://www.bogaziciventures.com/en",
        "contactUs": "Buğra Öklen",
        "contactUsEmail": "bugra@bogaziciventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/bogazici.jpg"
    },
    {
        "ventureCapitalFund": "Boğaziçi Ventures Sinerji",
        "mainInstitution": "BV Portfolio Management Inc. ",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A co-investment fund that focuses on seed to Series A investments  with international co-investors.",
        "details": "Investing in disruptive technology companies by a \"co-investment\" approach in collaboration with successful venture capital funds, investment banks, and other strategic investors both local and globally.",
        "sectoralPreferences": "1,8,4,5,19,20,7,22",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$ 20 M",
        "ticketSize": "$100-200 K",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://bvportfoy.com/en",
        "contactUs": "Tuba Ayan",
        "contactUsEmail": "fonal@bvportfoy.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/bogazici.jpg"
    },
    {
        "ventureCapitalFund": "Collective Spark",
        "mainInstitution": "Collective Spark Fund BV",
        "foundedYear": 2018,
        "city": "Amsterdam",
        "hq": "The Netherlands",
        "summary": "A VC fund that invests in early-stage technology startups.",
        "details": "Collective Spark invests in early stage tech startups, primarily highly driven hustlers and hackers who want to build scalable, disruptive businesses. The fund invests at the pre-seed, seed, and Series A stages. While agnostic regarding industry sectors, it has primarily focused on fintech, B2B SaaS/Enterprise, marketplaces, and AI. The fund has a team of operational experts in marketing, growth, technology, and recruitment who provide support to entrepreneurs as needed. Collective Spark is co-investment-friendly and has co-invested in all of its deals to date.",
        "sectoralPreferences": "5,6,23,1",
        "geographicalPreferences": "Türkiye, Central Asia, Caucasus",
        "fundSize": "$ 40 M",
        "ticketSize": "$ 500 K- 2.5 M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://collectivespark.com/",
        "contactUs": "Atıl Erken\nGörkem Oktay",
        "contactUsEmail": "atil.erken@collectivespark.com\ngorkem.oktay@collectivespark.com",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/collective.jpg"
    },
    {
        "ventureCapitalFund": "Oxtech Ventures",
        "mainInstitution": "Deniz Portfolio Management Inc. Oxtech Sustainable Technology Investments VCIF",
        "foundedYear": 2024,
        "city": "Istanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in innovative, sustainability-driven startups, focusing on empowering entrepreneurs to scale their impact globally while fostering groundbreaking solutions across industries.",
        "details": "The fund has a total size of between 12-15 million USD and aims to invest in sustainable technology and early-stage companies over an 8-year period. The first closing is planned for 25 March 2025, with 5 million USD, and the final closing is scheduled for 25 March 2026, with a target size of 12-15 million USD. The fund accepts a minimum investment commitment of 100,000 EUR and targets a 20% IRR and 4x MOIC. Utilizing a de-risked model through support programs from DenizBank and Oxentia, the fund plans to invest in 15-20 companies. The fund primarily focuses on early-stage ventures with internationalization potential. Investments will prioritize companies that focus on environmental and social sustainability, and the fund's global access and wide investor network will provide an advantage in exit strategies. Investments will be aligned with companies that meet the United Nations Sustainable Development Goals. Especially SDGs; \n6- Clean Water and Sanitation\n7- Affordable and Clean Energy\n8- Decent Work and Economic Growth\n9- Industry, Innovation, and Infrastructure\n11- Sustainable Cities and Communities\n12- Responsible Consumption and Production\n13- Climate Action\n14- Life Below Water\n15- Life on Land",
        "sectoralPreferences": "17",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$ 12-15 M",
        "ticketSize": "$ 150-300 K ",
        "investmentStrategyText": "Pre-Seed, Seed",
        "website": "https://www.oxtechventures.com",
        "contactUs": "Siret Ünsal",
        "contactUsEmail": "siret@oxtechventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            1,
            2
        ],
        "logo":"/images/logos/oxtech-venterus.jpg"
    },
    {
        "ventureCapitalFund": "Diffusion Capital Partners",
        "mainInstitution": "Diffusion Capital Partners",
        "foundedYear": 2015,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in seed stage and Series A deep tech companies.",
        "details": "Diffusion Capital Partners (DCP) is a venture capital firm focused on deep-tech investments, backing startups that use advanced science and technology to disrupt traditional industries. Established in 2015, DCP primarily invests in early-stage technology companies, providing Seed and Series A funding. The firm seeks startups with strong technical potential, particularly those operating in interdisciplinary fields that integrate various technology domains. Beyond funding, DCP offers its portfolio companies strategic guidance, business development support, and operational expertise to accelerate growth. The firm is sector-agnostic and open to opportunities that address global challenges.\n",
        "sectoralPreferences": "1,22,11,22,12",
        "geographicalPreferences": "Türkiye, Europe",
        "fundSize": "€ 100 M",
        "ticketSize": "€ 250 K- 2.5 M",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://www.dcp.vc",
        "contactUs": "Damla Küçük",
        "contactUsEmail": "damla@dcp.vc",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 2,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/dcp.jpg"
    },
    {
        "ventureCapitalFund": "DOMiNO Ventures",
        "mainInstitution": "Domino Ventures Fund Cooperatief U.A.",
        "foundedYear": 2022,
        "city": "Amsterdam",
        "hq": "The Netherlands",
        "summary": "A VC fund that focuses on high-tech, pure-digital and first-day global startups from Türkiye, Central Asia and Caucasus  with an ambition to create domino effect for better future. ",
        "details": "DOMiNO Ventures is a venture capital fund focused on high-tech, pure-digital, and globally scalable startups. Operating worldwide, the fund has offices in Istanbul, Amsterdam, Estonia, Poland, Georgia, Azerbaijan, Kazakhstan, and Uzbekistan. DOMiNO Ventures supports founders who are addressing modern global challenges across industries such as AI, DeepTech, CleanTech, HealthTech, FinTech, HrTech, EdTech, GameTech, CyberSecurity, and Life Science. The fund's investors include leading corporations, strategic partners, and individual investors. As of October 2023, DOMiNO Ventures has made 18 investments. Over the next two years, the fund plans to invest in 15 new startups, with a particular emphasis on high-tech ventures and AI-driven solutions with global impact. \nDOMiNO Ventures offers an initial investment ticket size of €100K to €300K, with follow-on investments ranging from €250K to €1M.",
        "sectoralPreferences": "1,11,17,22,5,7,20,4,10",
        "geographicalPreferences": "Türkiye, Central Asia, Caucasus",
        "fundSize": "€ 30 M",
        "ticketSize": "€100 K - 1 M ",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.dominovc.com",
        "contactUs": "Mustafa Kopuk\nYağız Karadeniz",
        "contactUsEmail": "mustafa@dominovc.com\nyagiz@dominovc.com",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/dominoo.jpg"
    },
    {
        "ventureCapitalFund": "Fark Labs Ventures",
        "mainInstitution": "Fark Labs Ventures",
        "foundedYear": 2024,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in technologies for a better future, driving sustainability and innovation with a focus on net-zero carbon, mobility, advanced materials, renewable energy, healthtech, industrial circularity, essential human needs, and electrification solutions",
        "details": "Fark Labs Ventures invests in technologies for a better future, from net-zero carbon solutions to electrification, innovative mobility, advanced materials science, and renewable energy. By prioritizing sustainability-focused areas such as industrial circularity and essential human needs (water, food, agriculture), the fund accelerates clean energy transition through targeted electrification. This approach enables environmental and social value creation, fostering a more livable world.\nFark Labs Ventures also strategically supports impact-driven entrepreneurs, promoting innovation and sustainability. The fund backs technologies that directly improve lives and supports industrial applications rooted in the circular economy, creating a positive future through more efficient resource use.  This investment model from Türkiye serves as a global example of sustainability and innovation.",
        "sectoralPreferences": "17,17,14,12,22,8,8",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$ 15 M",
        "ticketSize": "$50 K-2 M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.farklabs.com/",
        "contactUs": "Erhan Ak",
        "contactUsEmail": "erhan.ak@farklabs.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 2,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/farklabs.jpg"
    },
    {
        "ventureCapitalFund": "Alkima Partners",
        "mainInstitution": "Foneria Portföy Yönetimi A.Ş. Alkima Girişim Sermayesi Yatırım Fonu",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A mid-market PE firm specializing on growth capital investments with a focus on Türkiye.",
        "details": "Alkima Partners, founded by the partners of Taxim Capital in 2023, is a private equity firm focused on investing in fast-growing medium-sized companies in Türkiye. The firm primarily seeks businesses that are leaders or have the potential to become leaders in their sectors, possess a competitive edge, have a well-established business model, operate within the right partnership structure, and are managed by the right partner and management team. Alkima Partners focuses on business areas that leverage Türkiye's advantage of a qualified workforce with high productivity and emphasize fast supply, fast shipping, and flexible order volume, ensuring agility in meeting international market demands. Additionally, Alkima Partners prioritizes companies that export or have strong potential for overseas expansion, whether in products or services.\nWhile Alkima Partners is sector-agnostic, the firm tends to favor investments in industrial manufacturing companies, service companies, consumer products manufacturing and marketing companies, and technology companies. In its investments, Alkima Partners typically takes between 20% and 60% equity stakes and aims to invest 90% of its fund in mid-cap companies with a proven positive cash flow track record. The remaining 10% is reserved for high-potential startups or alternative investments.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺3 B",
        "ticketSize": "₺100 M-500 M ",
        "investmentStrategyText": "Series A and above ",
        "website": "https://alkimapartners.com/",
        "contactUs": "Berkin Tevs Mungan",
        "contactUsEmail": "berkin.mungan@alkimapartners.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            4
        ],
        "logo":"/images/logos/alkima.jpg"
    },
    {
        "ventureCapitalFund": "Driventure",
        "mainInstitution": "Ford Otosan Driventure ",
        "foundedYear": 2019,
        "city": "Istanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in early-stage mobility, manufacturing technologies and smart mobility.",
        "details": "Driventure, Ford Otosan's corporate venture capital company, is a company that invests in mobility, manufacturing technologies and smart mobility. Founded in 2019, Driventure invests mainly in seed and early-stage startups. It also tries to establish a bridge between external startups and Ford Otosan and to ensure that Ford Otosan becomes a customer of suitable startups. It invests between 50,000 - 250,000 USD in early-stage startups. As of October 2024, it has invested in 9 startups.",
        "sectoralPreferences": "14,12",
        "geographicalPreferences": "Türkiye, USA, Europe",
        "fundSize": "$ 2 M ",
        "ticketSize": "$ 50 K- 250 K ",
        "investmentStrategyText": "Pre-seed, Seed, Pre-Series A",
        "website": "https://www.driventure.vc",
        "contactUs": "Eren Atli",
        "contactUsEmail": "Eatli1@ford.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2
        ],
        "logo":"/images/logos/driventure.jpg"
    },
    {
        "ventureCapitalFund": "Hummingbird Ventures",
        "mainInstitution": "Hummingbird Ventures",
        "foundedYear": 2010,
        "city": "London",
        "hq": "United Kingdom",
        "summary": "A VC fund that invests in early stage companies with outlier founders globally.",
        "details": "Hummingbird Ventures is an early stage generalist fund that focuses on pre-seed to Series A checks, ranging from $500K to $15M. Hummingbird has partnered up with some exceptional companies as one of their first invesstors, including Peak Games (Türkiye), Deliveroo (UK), Kraken (US), Billiontoone (US), Onecard (India) and many others. ",
        "sectoralPreferences": "11,1,22,5",
        "geographicalPreferences": "Global",
        "fundSize": "$200 M",
        "ticketSize": "$ 500 K-15 M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.hummingbird.vc",
        "contactUs": "Firat Ileri",
        "contactUsEmail": "firat@hummingbird.vc",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/hummingbird.jpg"
    },
    {
        "ventureCapitalFund": "Inveo Ventures Co-Investment VCIF",
        "mainInstitution": "Inveo Portfolio Management Inc. ",
        "foundedYear": 2022,
        "city": "Istanbul",
        "hq": "Türkiye",
        "summary": "A CVC fund focusing on early to mid-stage, technology-based Turkish startups with a sector-agnostic structure in collaboration with other VC firms.",
        "details": "Inveo Ventures, established in 2022 as a corporate venture capital structure in partnership with Gedik Investment, a leading brokerage house in capital markets for over 30 years, and its affiliated group Inveo Investment Holding, focuses on early-stage and bridge-stage investment rounds within the Turkish Entrepreneurship Ecosystem. The fund aims to invest alongside leading venture capital funds and targets the discounted acquisition of shares in companies that have received strategic and/or VC investments, available for sale in the secondary market. In addition to finullcial investments, Inveo Ventures provides non-cash support, including business development, mentoring, and team structuring, to the startups it invests in, positioning itself as the center of the group's technology investment. With a targeted fund size of 10 million USD, the fund currently has investments in 9 companies. As of October 2024, Inveo Ventures' direct and indirect active venture portfolio includes more than 70 technology companies, including the fund structures managed or partnered by the group and ventures directly invested in.",
        "sectoralPreferences": "1,5,6,1,1,17,10,14,2,23",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$ 20 M",
        "ticketSize": "$100 K- 1.5 M",
        "investmentStrategyText": "All stages",
        "website": "https://www.inveoportfoy.com\nhttps://inveoventures.com/",
        "contactUs": "Bayram Erol\nHaluk Nişli ",
        "contactUsEmail": "bayram.erol@inveoportfoy.com\nhaluk.nisli@inveo.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":"/images/logos/inveo.jpg"
    },
    {
        "ventureCapitalFund": "Kuveyt Türk Asset Management Kobi VCIF",
        "mainInstitution": "Kuveyt Türk Ventures",
        "foundedYear": 2022,
        "city": "İstanbul ",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in late-stage companies with sector-specific experience.",
        "details": "The Kobi Venture Capital Investment Fund (VCIF), established and managed by Kuveyt Türk Ventures, aims to invest in firms that bring innovation, sectoral expansion, or regional advancement with the potential to add value to the Turkish economy. The Fund targets companies with long-standing credibility in the business world, based on industry experience and business ethics, with growth objectives, such as acquiring new production tools, entering new markets, or increasing capacity. Its focus includes firms operating in sectors such as information technology, telecommunications, food, healthcare, energy, natural resources, manufacturing, and service industries.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 200 M ",
        "ticketSize": "$ 500 K - 1.5 M ",
        "investmentStrategyText": "Series A, Series B",
        "website": "https://www.kuveytturkportfoy.com.tr/girisim-sermayesi-yatirim-fonlari/kobi",
        "contactUs": "Ramazan Bayram",
        "contactUsEmail": "girisimsermayesi@ktportfoy.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            3
        ],
        "logo":"/images/logos/kuveytturkventures.jpg"
    },
    {
        "ventureCapitalFund": "Kuveyt Türk Asset Management Lonca VCIF",
        "mainInstitution": "Kuveyt Türk Ventures",
        "foundedYear": 2020,
        "city": "İstanbul ",
        "hq": "Türkiye",
        "summary": "A VC fund that focuses on early-stage technology startups with a sector-agnostic approach.",
        "details": "The Lonca Venture Capital Investment Fund (VCIF), founded by Kuveyt Türk Ventures, is dedicated to investing in startups at the early and growth stages, whether already operational or in the planning phase. The Fund targets enterprises with significant growth prospects that need finullcial support to achieve their objectives, particularly those providing technological innovations in finullcial technologies, healthcare technologies, transportation technologies, and various service and commerce industries. Thus far, the Fund has invested in 14 distinct startups, and its investment activities continue.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 230 M ",
        "ticketSize": "$ 50 K- 500 K",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://kuveytturkportfoy.com.tr/loncagirisim/default.aspx",
        "contactUs": "Ramazan Bayram",
        "contactUsEmail": "girisimsermayesi@ktportfoy.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/kuveytturkventures.jpg"
    },
    {
        "ventureCapitalFund": "Kuveyt Türk Asset Management Neova Katılım Sigorta Özel VCIF",
        "mainInstitution": "Kuveyt Türk Ventures",
        "foundedYear": 2022,
        "city": "İstanbul ",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in early-stage startups in the field of insurance technologies.",
        "details": "The Neova Participation Insurance Private Venture Capital Investment Fund (VCIF), established and managed by Kuveyt Türk Ventures, is an investment fund created to support entrepreneurs, primarily in the insurance sector (InsurTech), and technology-based ventures with the potential to make a global impact. Its purpose is to invest in these ventures and contribute to their growth.",
        "sectoralPreferences": "5",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 6 M",
        "ticketSize": "$ 50 K -500 K ",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://kuveytturkportfoy.com.tr/girisim-sermayesi-yatirim-fonlari/neova",
        "contactUs": "Ramazan Bayram",
        "contactUsEmail": "girisimsermayesi@ktportfoy.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/kuveytturkventures.jpg"
    },
    {
        "ventureCapitalFund": "Laton Ventures",
        "mainInstitution": "Laton Ventures GP B.V. ",
        "foundedYear": 2023,
        "city": "Amsterdam",
        "hq": "The Netherlands",
        "summary": "A VC fund that invests in early-stage gaming and gaming-adjacent startups.",
        "details": "Laton Ventures, a Netherland-based Venture Capital Investment Fund, focuses on investments in gaming and gaming-adjacent startups. By acquiring minority stakes ranging from 5% to 25%, the Fund specializes in early-stage ventures to foster innovative projects in the industry. Also, upon request of the startups, Laton Ventures provides hands-on operational support to its portfolio companies by leveraging its industry network to help them thrive. With a fund size reaching USD 50 million, its investors include strategic partners and Turkish and global gaming industry veterans. Until October 2024, Laton Ventures had completed five investments. ",
        "sectoralPreferences": "4",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$ 50 M",
        "ticketSize": "$ 500 K - 2 M ",
        "investmentStrategyText": "Pre-seed, Seed",
        "website": "https://laton.vc/",
        "contactUs": "Görkem Türk",
        "contactUsEmail": "contact@laton.vc",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2
        ],
        "logo":"/images/logos/laton.jpg"
    },
    {
        "ventureCapitalFund": "Leap Investment",
        "mainInstitution": "Leap Technology Investment Inc.",
        "foundedYear": 2021,
        "city": "Ankara",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in sector-agnostic early stage startups using smart capital.",
        "details": "LEAP Investment is a venture capital fund that invests in early-stage startups with smart capital, combining finullcial investment with hands-on support. It offers advisory and mentoring services, helping entrepreneurs grow and succeed by staying closely involved in their development. With a network of investors bringing experience from various sectors, LEAP Investment provides startups with valuable insights and connections in both local and international markets. As of October 2024, it has participated in 12 funding rounds, supporting 9 startups, and made 3 follow-on investments to help its portfolio companies scale. As a founding partner of Ankara TEKMER, LEAP Investment is dedicated to accelerating its investments and fostering the growth of Türkiye’s entrepreneurial ecosystem.",
        "sectoralPreferences": "1,22,4,6,16,10,17,11,8,5",
        "geographicalPreferences": "Türkiye, Europe, US, UK",
        "fundSize": "$ 5 M",
        "ticketSize": "$50K-300K ",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.leapinvestment.co",
        "contactUs": "İmran Gürakan",
        "contactUsEmail": "imrangurakan@leapinvestment.co",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/leap.jpg"
    },
    {
        "ventureCapitalFund": "Code VCIF",
        "mainInstitution": "Letven Capital Venture Capital Portfolio Management Company Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in startups from seed to Series B stages, focusing on fintech, information and communication technologies, and deep technology.",
        "details": "CODE Ventures makes equity investments ranging from 15% to 30% in companies within these sectors. As of October 2024, the fund's size is 191 million TRY, and it has invested in 3 companies so far. Its investors include individual retirement funds, institutional and qualified investors, and R&D funds from companies. The fund aims to invest in suitable opportunities within its focus sectors.",
        "sectoralPreferences": "5,11",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 191 M",
        "ticketSize": "₺10 M-100 M",
        "investmentStrategyText": "Seed, Series A, Series B",
        "website": "https://www.letvencapital.com/en/invest-in-our-funds/venture-capital-investment-funds/code-venture-capital-investment-fund",
        "contactUs": "Levent Tarhan",
        "contactUsEmail": "levent.tarhan@letvencapital.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/letven-code.jpg"
    },
    {
        "ventureCapitalFund": "Genius VCIF",
        "mainInstitution": "Letven Capital Venture Capital Portfolio Management Company Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in startups from pre-seed to Series A stages, focusing on green economy and circular economy initiatives. ",
        "details": "GENİUS Ventures makes equity investments ranging from 10% to 25% in companies within these sectors. The fund has not made any investments yet but continues to seek investors, including individual retirement funds, institutional and qualified investors, and R&D funds from companies.",
        "sectoralPreferences": "17",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 251 K",
        "ticketSize": "₺5M-50 M",
        "investmentStrategyText": "Pre-Seed, Seed, Series A",
        "website": "https://www.letvencapital.com/en/invest-in-our-funds/venture-capital-investment-funds/genius-venture-capital-investment-fund",
        "contactUs": "Levent Tarhan",
        "contactUsEmail": "levent.tarhan@letvencapital.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            1,
            2,
            3
        ],
        "logo":"/images/logos/letven-genius.jpg"
    },
    {
        "ventureCapitalFund": "Milres VCIF",
        "mainInstitution": "Letven Capital Venture Capital Portfolio Management Company Inc.",
        "foundedYear": 2019,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in startups from Series A to Series C stages, focusing on robotic, battery, manufacturing, and educational technologies.",
        "details": "MİLRES Ventures makes equity investments ranging from 10% to 30% in companies within these sectors; robotic, battery technologies, manufacturing and educational technologies. The fund's size is 5.8 billion TRY. It has invested in 11 companies so far. Its investors include individual retirement funds, institutional and qualified investors, and R&D funds from companies. The fund has made a partial exit from one of its portfolio companies through an initial public offering (IPO).",
        "sectoralPreferences": "18,12,20",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 5.9 B",
        "ticketSize": "₺10 M-350 M",
        "investmentStrategyText": "Series A, Series B, Series C",
        "website": "https://www.letvencapital.com/en/invest-in-our-funds/venture-capital-investment-funds/milres-venture-capital-investment-fund",
        "contactUs": "Levent Tarhan",
        "contactUsEmail": "levent.tarhan@letvencapital.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            3
        ],
        "logo":"/images/logos/letven-milres.jpg"
    },
    {
        "ventureCapitalFund": "Preo VCIF",
        "mainInstitution": "Letven Capital Venture Capital Portfolio Management Company Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in startups from seed to Series B stages, focusing on mobility, last-mile logistics solutions, and energy technologies.",
        "details": "PREO Ventures makes equity investments ranging from 10% to 25% in companies within these sectors. The fund currently has a size of 80 million TRY and has made one investment so far, with a target of reaching 500 million TRY in fund size. The fund continues to seek investors, including individual retirement funds, institutional and qualified investors, and R&D funds from companies.",
        "sectoralPreferences": "14,15,18",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 80 M",
        "ticketSize": "₺10M-15M",
        "investmentStrategyText": "Seed, Series A, Series B",
        "website": "https://www.letvencapital.com/en/invest-in-our-funds/venture-capital-investment-funds/preo-venture-capital-investment-fund",
        "contactUs": "Levent Tarhan",
        "contactUsEmail": "levent.tarhan@letvencapital.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/letven-preo.jpg"
    },
    {
        "ventureCapitalFund": "Retina VCIF",
        "mainInstitution": "Letven Capital Venture Capital Portfolio Management Company Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in startups from pre-seed to Series A stages, focusing on real estate technologies.",
        "details": "RETINA Ventures makes equity investments ranging from 10% to 25% in companies within this sector. The fund has not made any investments yet, but it continues to seek investors, including individual retirement funds, institutional and qualified investors, and R&D funds from companies.",
        "sectoralPreferences": "16",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 133 K",
        "ticketSize": "₺5 M-50 M",
        "investmentStrategyText": "Pre-Seed, Seed, Series A",
        "website": "https://www.letvencapital.com/en/invest-in-our-funds/venture-capital-investment-funds/retina-venture-capital-investment-fund",
        "contactUs": "Levent Tarhan",
        "contactUsEmail": "levent.tarhan@letvencapital.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            1,
            2,
            3
        ],
        "logo":"/images/logos/letven-retina.jpg"
    },
    {
        "ventureCapitalFund": "Sofa VCIF",
        "mainInstitution": "Letven Capital Venture Capital Portfolio Management Company Inc.",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in startups from pre-seed to Series A stages, focusing on furniture and textile technologies. ",
        "details": "SOFA Ventures makes equity investments ranging from 10% to 25% in companies within furniture and textile sectors. The fund has not made any investments yet but continues to seek investors, including individual retirement funds, institutional and qualified investors, and R&D funds from companies.",
        "sectoralPreferences": "13",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 10 K",
        "ticketSize": "₺5 M-50 M",
        "investmentStrategyText": "Pre-Seed, Seed, Series A",
        "website": "https://www.letvencapital.com/en/invest-in-our-funds/venture-capital-investment-funds/sofa-venture-capital-investment-fund",
        "contactUs": "Levent Tarhan",
        "contactUsEmail": "levent.tarhan@letvencapital.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            1,
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "Tars VCIF",
        "mainInstitution": "Letven Capital Venture Capital Portfolio Management Company Inc.",
        "foundedYear": 2019,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in startups from seed to Series B stages, focusing on the agriculture, food, and technology sectors.",
        "details": "TARS Ventures invests in equity stakes ranging from 10% to 25% in companies within these sectors, acting as an investor during their seed, Series A, and Series B phases. The fund has a size of 615 million TRY and has made investments in 10 companies so far. Its investors include individual retirement funds, institutional and qualified investors, and R&D funds from companies. No exits have been made yet from the portfolio companies. The fund focuses on investments in the manufacturing, technology, and agricultural finullce verticals. It aims to contribute to the agricultural sector in Türkiye while delivering high returns to its investors by creating value.",
        "sectoralPreferences": "8",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 615 M",
        "ticketSize": "₺10M-50 M",
        "investmentStrategyText": "Seed, Series A, Series B",
        "website": "https://www.letvencapital.com/en/invest-in-our-funds/venture-capital-investment-funds/tars-venture-capital-investment-fund",
        "contactUs": "Levent Tarhan",
        "contactUsEmail": "levent.tarhan@letvencapital.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "Timus VCIF",
        "mainInstitution": "Letven Capital Venture Capital Portfolio Management Company Inc.",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in startups from pre-seed to Series A stages, focusing on healthcare and health technologies. ",
        "details": "TİMUS Ventures makes equity investments ranging from 10% to 25% in companies within these sectors. The fund has not made any investments yet but continues to seek investors, including individual retirement funds, institutional and qualified investors, and R&D funds from companies.",
        "sectoralPreferences": "22",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 10 K",
        "ticketSize": "₺5M-50M",
        "investmentStrategyText": "Pre-Seed, Seed, Series A",
        "website": "https://www.letvencapital.com/en/invest-in-our-funds/venture-capital-investment-funds/timus-venture-capital-investment-fund",
        "contactUs": "Levent Tarhan",
        "contactUsEmail": "levent.tarhan@letvencapital.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            1,
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "Founder One VCIF",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A next-generation impact investment fund that supports early-stage technology-focuses impact startups.",
        "details": "Founder One, launched in 2023, invests in Türkiye-based startups, focusing on generating returns by creating medium and long-term value through venture capital investments. The Fund directs finullcial resources toward impact-driven ventures, particularly in ClimateTech, EdTech, HealthTech, Disaster, Agriculture, Inclusion, and Data Security, aiming to create a sustainable positive impact on society or the environment. With a fund size of 300 million TL, Founder One has already invested in 39 impact-focused startups, targeting 80 by the end of its investment period. Its investors include major holdings, corporate and public entities, and technology entrepreneurs. The Fund also emphasizes ventures with measurable impact targets and aims to reinvest returns within the ecosystem to foster further growth and innovation.",
        "sectoralPreferences": "17,20,22,8,10",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 500 M",
        "ticketSize": "₺3 M -5 M",
        "investmentStrategyText": "Pre-seed, Seed",
        "website": "https://www.founderone.com",
        "contactUs": "Muhammed Gültekin",
        "contactUsEmail": "info@founderone.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2
        ],
        "logo":"/images/logos/founderone.jpg"
    },
    {
        "ventureCapitalFund": "Arya Ventures VCIF",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in women-founded technology startups at seed & Series A stage.",
        "details": "As Türkiye's gender-focused venture capital fund, Arya VC aims for strong returns and emphasizes gender-balanced investments. The fund incorporates diversity as a key investment criterion, focusing on startups with gender-balanced founding teams. Preferred sectors include e-commerce technologies, biotech, agritech, consumer products and services, logistics, cleantech, cybertech, edtech, femtech, foodtech, and AI. The Arya Women Investment Platform ecosystem, comprising nearly 500 members across Türkiye, the US, MENA, and Europe, connects female entrepreneurs and startups with diverse founding teams. Arya’s programs support investment pipeline creation for the fund and provide portfolio companies with growth and development opportunities through its network. 85% of the fund's portfolio companies are established in Türkiye, with 51% of their consolidated assets located in Türkiye. Türkiye İş Bankası serves as the administrator, custodian, and lead investor for the fund, with a commitment of $5M. The fund has a target size of $25M, with 17 institutional and 80 individual investors as limited partners (LPs). It has made 13 investments up until October 2024, including one follow-on investment, and plans to make 13 additional investments in Q4 2024 and 2025.  ",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye ",
        "fundSize": "$18.2 M",
        "ticketSize": "$150 K-600 K",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://fund.aryawomen.com",
        "contactUs": "Selin Çelikel & Melisa Güvenç",
        "contactUsEmail": "analyst@aryawomen.com \n",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/arya.jpg"
    },
    {
        "ventureCapitalFund": "Maxis Yenilikçi VCIF",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2018,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in innovative, technology-oriented startups at the venture capital stage.",
        "details": "The Fund aims to invest in promising companies with high growth potential in Türkiye and abroad, primarily in startups seeking investment at early, advanced growth and bridge finullcing stages, and through the development of technology. In line with existing regulations, it is possible to invest in companies through equity, structured finullcing in the form of a debt/equity mix, or the acquisition of debt instruments. It aims to create an investment portfolio with high return potential at a reasonable risk level by investing in one or more phases per venture.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺384 M",
        "ticketSize": "$200K-500 K",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://www.maxisgs.com/",
        "contactUs": "Uğur Özker\nEge Ünlü",
        "contactUsEmail": "uozker@maxisgs.com\neunlu@maxisgs.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/maxis.jpg"
    },
    {
        "ventureCapitalFund": "Maxis Temiz Enerji VCIF",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2019,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "An investment fund that invests in renewable energy companies.",
        "details": "In line with the growth potential of the Turkish economy, the Fund aims to invest in companies operating in the renewable energy sector, which responds to the increasing demand for energy with an increasing share in line with the growth potential of the Turkish economy, or in companies that provide complementary services to producers operating in this sector. Companies that generate stable income and/or promise growth are prioritized in investment preferences. ",
        "sectoralPreferences": "17",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺4 M",
        "ticketSize": "€ 30 M",
        "investmentStrategyText": "Series F and above",
        "website": "https://www.maxisgs.com/",
        "contactUs": "Uğur Özker\nEge Ünlü",
        "contactUsEmail": "uozker@maxisgs.com\neunlu@maxisgs.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":"/images/logos/maxis.jpg"
    },
    {
        "ventureCapitalFund": "Maxis Atlas Büyüme Sermayesi VCIF",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2021,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "An investment fund that invests in companies with high growth prospects, operational profitability, a strong management team, and high competitiveness.",
        "details": "The Fund aims to generate medium and long-term value-based returns by investing in companies operating primarily in the industry, technology, healthcare, services, consumption and energy sectors. The main characteristics of the companies in the Fund's investment focus include their ability to generate income and growth potential or their need for restructuring. In accordance with existing regulations, the goal is to create an investment portfolio with high return potential at a reasonable risk level, through investments made in one or more phases per investment.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺1.9 B",
        "ticketSize": "$5M-20 M",
        "investmentStrategyText": "Series F and above",
        "website": "https://www.maxisgs.com/",
        "contactUs": "Uğur Özker\nEge Ünlü",
        "contactUsEmail": "uozker@maxisgs.com\neunlu@maxisgs.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [],
        "logo":"/images/logos/maxis.jpg"
    },
    {
        "ventureCapitalFund": "Maxis E-Ticaret Girişim Sermayesi Yatırım Fonu",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2021,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "An investment fund that invests in Trendyol.",
        "details": "The Fund will invest exclusively in the shares of DSM Grup Danışmanlık İletişim ve Satış Ticaret A.Ş. (“Trendyol”) and will not invest in any other company. Through additional investments in Trendyol, the Fund may also make investments solely for (i) regulatory compliance or (ii) liquidity management purposes in assets and transactions other than Trendyol.\n\n\n\n\n\n",
        "sectoralPreferences": "23",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺1.2 M",
        "ticketSize": "$65 M",
        "investmentStrategyText": "Series F and above",
        "website": "https://www.maxisgs.com/",
        "contactUs": "Uğur Özker\nEge Ünlü",
        "contactUsEmail": "uozker@maxisgs.com\neunlu@maxisgs.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":"/images/logos/maxis.jpg"
    },
    {
        "ventureCapitalFund": "Maxis T-Fon VCIF",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "An investment fund that invests in companies for growth capital, acquisitions, or restructuring purposes.",
        "details": "Within the framework of capital markets legislation, the Fund aims to generate returns by creating medium and long-term value through investments in SME-qualified companies with operating profit, high growth potential, competitive differentiation, and foreseeable exit opportunities. The focus is primarily on companies operating in the technology, agriculture, food, manufacturing, and service sectors.\n\n\n\n\n\n",
        "sectoralPreferences": "12,22,6,18",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺75 M",
        "ticketSize": "$500 K",
        "investmentStrategyText": "Series F and above",
        "website": "https://www.maxisgs.com/",
        "contactUs": "Uğur Özker\nEge Ünlü",
        "contactUsEmail": "uozker@maxisgs.com\neunlu@maxisgs.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":"/images/logos/maxis.jpg"
    },
    {
        "ventureCapitalFund": "Maxis Ventures VCIF",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in companies with growth potential, innovative applications and technologies, and the ability to scale easily.",
        "details": "The Fund aims to invest as a minority shareholder with an amount of USD 100 thousand or more per company, primarily targeting companies that have the potential to create value and seek finullcial and strategic support. The goal is to build an investment portfolio that balances reasonable risk with relatively high return potential. Fund assets may be allocated to a single investment or directed to multiple investments. The three main areas in which the Fund seeks to add value are ensuring steady cash flow for companies, increasing operating profits, and achieving healthy growth.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺60 M",
        "ticketSize": "$100K-200 K",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://www.maxisgs.com/",
        "contactUs": "Uğur Özker\nEge Ünlü",
        "contactUsEmail": "uozker@maxisgs.com\neunlu@maxisgs.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/maxis.jpg"
    },
    {
        "ventureCapitalFund": "Maxis TSKB VCIF",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "An investment fund that invests in companies with high growth potential, competitive differentiation, and foreseeable exit opportunities, particularly in the energy, technology, food, manufacturing, agriculture, and services sectors.",
        "details": "The Fund aims to invest in companies with the potential to create value and that seek finullcial and strategic support, primarily focusing on investments in the range of USD 1 - 5 million per company. These investments may involve minority or majority shareholding or any other means permitted by legislation, with the goal of building an investment portfolio that balances reasonable risk with relatively high return potential. Fund assets may be allocated to a single investment or distributed across multiple investments. The three main areas in which the Fund seeks to add value are ensuring steady cash flow for companies, increasing operating profit, and achieving healthy growth.",
        "sectoralPreferences": "18,8,12,6",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺128 M",
        "ticketSize": "$1-5 M",
        "investmentStrategyText": "Series F and above",
        "website": "https://www.maxisgs.com/",
        "contactUs": "Uğur Özker\nEge Ünlü",
        "contactUsEmail": "uozker@maxisgs.com\neunlu@maxisgs.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":"/images/logos/maxis.jpg"
    },
    {
        "ventureCapitalFund": "Maxis 100. Yıl VCIF",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in technology-oriented startup companies, prioritizing those with a value proposition in finullcial technologies.",
        "details": "The Fund aims to invest in technology-oriented ventures, with priority given to companies that have the potential to create value and seek finullcial and strategic support, especially those that offer a value proposition in finullcial technologies. The investment amount per company may vary depending on minority shareholding and investment thesis, and may reach up to USD 50 million. It is aimed to invest in 1-10 companies with the entire fund assets. Within the framework of these targets and the Fund's overall investment strategy, the Fund's investment amount and number of investments may adjust based on conditions and opportunities, and the investment amount per company may increase.",
        "sectoralPreferences": "5",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺2.5 B",
        "ticketSize": "$100K- 50 M",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://www.maxisgs.com/",
        "contactUs": "Uğur Özker\nEge Ünlü",
        "contactUsEmail": "uozker@maxisgs.com\neunlu@maxisgs.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/maxis.jpg"
    },
    {
        "ventureCapitalFund": "Maxis Türkiye Yeşil Finulls Projesi VCIF",
        "mainInstitution": "Maxis Venture Capital Portfolio Management Inc.",
        "foundedYear": 2024,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "An investment fund that invests in venture companies focused on emission reduction, inclusive transformation, and the green transformation process.",
        "details": "The Fund was established by Türkiye Sınai Kalkınma Bankası Anonim Şirketi with the guarantee of the Republic of Türkiye Ministry of Treasury and Finullce, as part of the Türkiye Green Finullce Project. It focuses on the creation of a venture capital investment fund aimed at emission reduction and inclusive transformation, supported by a loan from the International Bank for Reconstruction and Development (IBRD).",
        "sectoralPreferences": "17",
        "geographicalPreferences": "Türkiye",
        "fundSize": "-",
        "ticketSize": "<$5M",
        "investmentStrategyText": "Series F and above",
        "website": "https://www.maxisgs.com/",
        "contactUs": "Uğur Özker\nEge Ünlü",
        "contactUsEmail": "uozker@maxisgs.com\neunlu@maxisgs.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":"/images/logos/maxis.jpg"
    },
    {
        "ventureCapitalFund": "Mediterra Capital Partners III, LP",
        "mainInstitution": "Mediterra Capital Partners III, LP",
        "foundedYear": 2023,
        "city": "Guernsey",
        "hq": "UK",
        "summary": "A private equity (PE) fund that invests in technology, consumer, and export-driven SMEs.",
        "details": "Mediterra aims to invest in Turkish SMEs in the technology, export, and consumer sectors by acquiring majority shares. Following the success of Fund I and Fund II, Fund III has been established. Fund I, with a total size of €164 million, exited 7 of its 8 investments. The exit process of the 8th company is still ongoing. Fund II, with a size of €166 million, exited 3 of its 8 investments within 2024. Fund III successfully completed its first closing in the Q2 of 2024, and the final closing is planned for the Q2 of 2025. The target size of the fund is €165 million. In the upcoming period, the fund plans to make 8 new investments, focusing on opportunities that will create a global impact.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "€165 M",
        "ticketSize": "€ 8 M-35 M",
        "investmentStrategyText": "Lower-Mid Market (LMM)",
        "website": "https://www.mediterracapital.com/  ",
        "contactUs": "Kubra Aygul Kubra Bas",
        "contactUsEmail": "kubra.aygul@mediterracapital.com / kubra.bas@mediterracapital.com",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [],
        "logo":"/images/logos/mediterra.jpg"
    },
    {
        "ventureCapitalFund": "TechOne VCIF",
        "mainInstitution": "Metis Ventures",
        "foundedYear": 2020,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in early stage startups with sector agnostic approach.",
        "details": "TechOne Venture Capital is an Istanbul-based Smart Capital Fund with a fund size of $25 million. It invests in seed and early-stage technology startups that aim to become global players through competitive advantages in technology and disruptive business models.\n\n",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye, CEE",
        "fundSize": "$ 25 M",
        "ticketSize": "$150K-1.5M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.techone.vc",
        "contactUs": "Yiğit Arslan",
        "contactUsEmail": "yarslan@istanbulportfoy.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/techone-venture-capital.jpg"
    },
    {
        "ventureCapitalFund": "Logo Ventures II VCIF",
        "mainInstitution": "Metis Ventures",
        "foundedYear": 2021,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in early-stage startups with a focus on B2B SaaS, AI, FinTech, and ClimateTech.",
        "details": "Logo Ventures is a venture capital fund with a total size of $20 million, investing in early-stage technology startups across Türkiye, Central and Eastern Europe, and the Baltic countries. The fund provides portfolio companies with access to a network of local and global mentors and investors, leveraging its expertise to help entrepreneurs become global industry leaders.\n\n\n\n\n\n",
        "sectoralPreferences": "6,1,5,17",
        "geographicalPreferences": "Türkiye, CEE",
        "fundSize": "$ 20 M",
        "ticketSize": "$150K-1.5M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "http://www.logoventures.com.tr",
        "contactUs": "Merve Zabcı",
        "contactUsEmail": "merve@logoventures.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/logo-venterus.jpg"
    },
    {
        "ventureCapitalFund": "twozero VCIF",
        "mainInstitution": "Metis Ventures",
        "foundedYear": 2020,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in sports, media, and entertainment ventures.",
        "details": "Twozero Ventures, with a fund size of $15 million, is Türkiye’s first sports-focused venture capital fund, investing in innovative startups within the sports, media, and entertainment sectors. The fund supports growth through strategic partnerships and operational expertise, shaping the future of these industries.\n\n\n\n\n\n",
        "sectoralPreferences": "19",
        "geographicalPreferences": "Türkiye ",
        "fundSize": "$ 15 M ",
        "ticketSize": "$150K-1.5M",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.twozero.vc",
        "contactUs": "Yiğit Arslan",
        "contactUsEmail": "yarslan@istanbulportfoy.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/two-zero.jpg"
    },
    {
        "ventureCapitalFund": "Metis VCIF",
        "mainInstitution": "Metis Ventures",
        "foundedYear": 2024,
        "city": "İstanbul, Amsterdam",
        "hq": "Türkiye & Holland",
        "summary": "A VC fund that focuses on early-stage investments from Türkiye and Eastern Europe, with an emphasis on driving innovation and regional growth.\n",
        "details": "Metis Ventures is a data-driven venture capital fund investing in early-stage technology startups across Türkiye, Central and Eastern Europe, and the Baltic countries. Focused on transformative and scalable businesses, Metis Ventures works closely with founders, providing expertise in strategy, operations, and growth, while leveraging its network of mentors and investors to help startups achieve their global ambitions.",
        "sectoralPreferences": "1,10,17,22,5",
        "geographicalPreferences": "Türkiye, CEE, Baltics",
        "fundSize": "€ 75 M",
        "ticketSize": "€1M-3M",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://www.metisventures.com/",
        "contactUs": "Merve Zabcı",
        "contactUsEmail": "merve@metisventures.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/metis.jpg"
    },
    {
        "ventureCapitalFund": "idacapital VCIF",
        "mainInstitution": "Nurol Portfolio Management Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in early-stage, post revenue, scalable businesses (preferably offering SaaS) that yield significant returns and have positive social and environmental impact.",
        "details": "Nurol Portföy Yönetimi A.Ş. İdacapital İvmelendirme VCIF primarily invests in startups in the Fintech sector, as well as in HealthTech, EduTech, ClimateTech, AgroTech, and LogiTech. The fund focuses on making impact investments based on measurable net finullcial returns, targeting scalable and post-revenue businesses in their early stages. The fund invests between $50K and $2M, achieving a total portfolio size of over 1.2 billion TL within two years.The current portfolio includes 11 ventures, all of which have received follow-on investments. The fund also plans to provide follow-on investments to its existing portfolio companies alongside new investments.",
        "sectoralPreferences": "5,22,20,8,17,15",
        "geographicalPreferences": "Türkiye, Euro-Central Asia, Europe, UK",
        "fundSize": "₺ 1.2 B",
        "ticketSize": "$ 50K-2 M",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://www.idacapital.com/",
        "contactUs": "Gülce Koç",
        "contactUsEmail": "gulce.koc@idacapital.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/idacapital.jpg"
    },
    {
        "ventureCapitalFund": "Revo Capital",
        "mainInstitution": "Revo Capital Management BV",
        "foundedYear": 2013,
        "city": "Amstelveen",
        "hq": "The Netherlands",
        "summary": "A VC fund that aims to invest in Series A by providing capital to early-stage, technology-focused startups in Türkiye and the CEE region, supporting their international growth.",
        "details": "Founded in 2013 as one of Türkiye's first technology investment funds, Revo Capital launched its initial fund of $66 million. In March 2020, it initiated a second fund of €90 million, which received investments from development institutions such as the IFC, EBRD, DEG, and EIF, as well as the Turkish Development and Investment Bank and other institutions in Türkiye. To date, Revo Capital has invested in 40 companies, including 2 unicorns, and has completed 17 exits. In the fourth quarter of 2024, Revo Capital began work on establishing a $100 million third fund aiming to support Türkiye's entrepreneurial ecosystem and continue its successful investment strategy built over the past decade.",
        "sectoralPreferences": "5,6,10,1,22,18,4",
        "geographicalPreferences": "Türkiye, Central Eastern Europe, the Baltics",
        "fundSize": "$185 M",
        "ticketSize": "$1 M-6 M",
        "investmentStrategyText": "Seed, Series A, Series B, Series C",
        "website": "ww.revo.vc",
        "contactUs": "Cenk Bayrakdar",
        "contactUsEmail": "cenk@revo.vc",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/revo-capital.jpg"
    },
    {
        "ventureCapitalFund": "ScaleX Ventures",
        "mainInstitution": "ScaleX Ventures Fund I Coöperatief UA",
        "foundedYear": 2019,
        "city": "Amsterdam",
        "hq": "The Netherlands",
        "summary": "A VC fund that invests in globally scalable technologies, with a unique emphasis on the Turkish Nexus.",
        "details": "ScaleX Ventures, based in the Netherlands, is an early-stage venture capital firm that invests in technology startups from Seed to Series A. The firm provides hands-on support to help startups with global growth potential scale rapidly. Founded by Dilek Dayınlarlı, who has over 12 years of VC experience, and Berkay Mollamustafaoglu, founder of OpsGenie, which is acquired by Atlassian for $295M, ScaleX Ventures focuses on connecting its portfolio companies with advisors, experts, and customers to drive growth.\n\n\n\n\n\n",
        "sectoralPreferences": "6,1,10,5",
        "geographicalPreferences": "Türkiye, Global",
        "fundSize": "€30 M",
        "ticketSize": "$250 K-1.5 M ",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.scalexventures.com",
        "contactUs": "Dilek Dayınlarlı Kocaata",
        "contactUsEmail": "dilek@scalexventures.com; contact@scalexventures.com",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "Startupfon Co-Investment Platform",
        "mainInstitution": "Startupfon Fund Coop",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A co-investment platform that aims to invest solely in startups backed by funds.",
        "details": "Startupfon is the co-investment platform in Türkiye that enables investment in startups approved by venture capital funds. Targeting qualified investors, Startupfon has reached a total of 3,000 registered investors and aims to facilitate decision-making processes through its Co-Invest Platform, while also serving as an educational resource. By managing critical processes such as access to deal flow, assessment of entrepreneurs, valuation, and negotiation of investment terms with its experienced team, Startupfon provides co-investment opportunities that address one of the biggest challenges for new investors looking to enter the ecosystem. In doing so, it plays a significant role in increasing the number of technology investors within the ecosystem.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "-",
        "ticketSize": "-",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.startupfon.com",
        "contactUs": "Gülsüm Çıracı",
        "contactUsEmail": "gulsum@startupfon.com",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "Future Impact VCIF",
        "mainInstitution": "Tacirler Asset Management Inc.",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "An impact investment VC fund that focuses on sector-agnostic investments in startups with high growth potential and strong technological and innovative aspects, at the seed or Series A stage.",
        "details": "The Future Impact Fund is a venture capital investment fund established by Vestel Ventures, a corporate venture capital firm in the Turkish entrepreneurship ecosystem, and Tacirler Portföy, a portfolio management company in Türkiye. The fund aims to support the development of startups by connecting investors with startups that have strong technological and innovative aspects at the seed or Series A stage.\n\nIt provides finullcial support to startups developing innovative technologies, alongside operational contributions from managers and investors with diverse sector experiences. The fund also offers technical and commercial support to assist in the growth of these startups.",
        "sectoralPreferences": "17,23,10,5,1,2",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$23 M",
        "ticketSize": "$ 500K ",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://www.vestelventures.com/\nhttps://tacirlerportfoy.com.tr/gelecek-etki-girisim-sermayesi-yatirim-fonu\n",
        "contactUs": "İlker Temuzkuşu\nKezban Taşoluk",
        "contactUsEmail": "ilker.temuzkusu@vestel.com.tr\nkezban.tasoluk@tacirlerportfoy.com.tr ",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "TTGV1 Co-Investment and Follow-On Fund",
        "mainInstitution": "Teknoloji Yatirim Inc.",
        "foundedYear": 2020,
        "city": "Amsterdam",
        "hq": "The Netherlands",
        "summary": "A VC fund that invests in early-growth stage technology startups with the potential for global scaling.",
        "details": "Teknoloji Yatirim, a subsidiary of the Technology Development Foundation of Türkiye (TTGV), invests in early-growth stage technological startups that have the potential to scale globally. Through a €30M fund, it has invested in 14 portfolio companies at the seed and Series A stages.",
        "sectoralPreferences": "1,6,17,22,24,20,17",
        "geographicalPreferences": "Global",
        "fundSize": "€ 30 M",
        "ticketSize": "€ 250 K-1.5 M",
        "investmentStrategyText": "Seed, Series A",
        "website": "https://www.teknolojiyatirim.com.tr/tr",
        "contactUs": "Ayça Uyanık",
        "contactUsEmail": "ayca.uyanik@teknolojiyatirim.com.tr\n\ninfo@teknolojiyatirim.com.tr",
        "isBasedInTurkey": false,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "Ludus Ventures VCIF",
        "mainInstitution": "TERA Portfolio Management Inc.",
        "foundedYear": 2021,
        "city": "Istanbul",
        "hq": "Türkiye",
        "summary": "A VC funds that invests in gaming and gaming technologies startups at pre-seed and seed rounds. ",
        "details": "A gaming sector-focused VCIF was established in collaboration with Ludus Ventures and Tera Portföy, in mobile game pre-seed and seed investments in the gaming sector. It has started its operations with the participation of active institutional investors, domestic and international funds in Türkiye's venture capital investments. As of today, Ludus Ventures is the most active gaming VCs in Türkiye and is among the world's top 20 most active gaming VCs. Ludus Ventures was founded by Volkan Biçer, Mehmet Ayan, Emre Gönül, and İsmet Gökşen, who have worked together for over ten years. Prior to founding Ludus Ventures, the team sold their digital media agency Mobilike to Opera in 2015. Later, in September 2020, they sold their majority stake in Rollic Games to the American gaming company Zynga. Since then, the team has focused exclusively on gaming investments. Since January 2021, they have made 19 investments to date through their first fund of $20mm established in Luxembourg and continue to invest in gaming startups all over the world. Tera Portfolio Ludus Ventures Venture Capital Investment Fund will focus solely on early-stage gaming investments in Türkiye as the team’s second fund. The fund successfully completed its first closing in the first quarter of 2024 and will make its final closing in 2025. Established with a target size of $20mm, the fund aims to invest in 19 different companies within 8 years, the last 2 years of which will be the liquidation period.\n",
        "sectoralPreferences": "4",
        "geographicalPreferences": "Türkiye/Global",
        "fundSize": "$25M-30 M",
        "ticketSize": "$ 750 K-1M",
        "investmentStrategyText": "Pre-seed, Seed",
        "website": "https://ludus.vc/",
        "contactUs": "İsmet Gökşen\nVolkan Biçer",
        "contactUsEmail": "ismet@ludus.vc\nvolkan@ludus.vc",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2
        ],
        "logo":"/images/logos/ludus.jpg"
    },
    {
        "ventureCapitalFund": "Regional Development Fund",
        "mainInstitution": "Türkiye Development Fund",
        "foundedYear": 2020,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in export-oriented or import-substituting companies and prioritized sectors in development.",
        "details": "The Regional Development Fund provides growth capital to SMEs that are export-oriented, import-substituting, or operate in priority development industries in order to reduce the current account deficit. The Fund's investors are the Republic of Türkiye Ministry of Industry and Technology and KOSGEB. As of October 2024, the Fund has invested in two companies.\n",
        "sectoralPreferences": "12",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 525 M ",
        "ticketSize": "$ 1-4 M",
        "investmentStrategyText": "Series B and above",
        "website": "https://www.Türkiyekalkinmafonu.com.tr/en/our-funds/regional-development-fund",
        "contactUs": "Türkiye Development Fund",
        "contactUsEmail": "info-tkf@kalkinma.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":""
    },
    {
        "ventureCapitalFund": "Development METU Teknokent VCIF (Invest101)",
        "mainInstitution": "Türkiye Development Fund",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund, established in cooperation with the Development Fund of Türkiye and METU Teknokent, invests in early-stage technology companies.",
        "details": "The aim of the Development METU Teknokent Venture Capital Investment Fund, known as Invest101, established through a partnership between the Development Fund of Türkiye and METU Teknokent, is to support early-stage, next-generation technology start-ups. Invest101 co-invests with other venture capital funds to help these early-stage start-ups progress to the growth stage. As of October 2024, the Fund has invested in 9 companies.",
        "sectoralPreferences": "1,2,3,10,12,14,18,17,8",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$ 11,7 M",
        "ticketSize": "$ 250 K - 1 M",
        "investmentStrategyText": "Seed, Pre-Series A",
        "website": "https://www.Türkiyekalkinmafonu.com.tr/en/our-funds/development-odtu-teknokent-vcif",
        "contactUs": "Türkiye Development Fund",
        "contactUsEmail": "invest101@kalkinma.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 2,
        "investmentStrategy": [
            2
        ],
        "logo":"/images/logos/invest101.jpg"
    },
    {
        "ventureCapitalFund": "Development Participation VCIF",
        "mainInstitution": "Türkiye Development Fund",
        "foundedYear": 2021,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund primarily investing in companies within strategic sectors prioritized for development, with high potential to boost exports and/or substitute imports, aligned with consumer demand, and benefiting from local demographics and the growth potential of the Turkish economy.\n",
        "details": "Development Participation Venture Capital Investment Fund aims to directly invest in companies operating in development priority sectors having a potential to reduce the current account deficit. Ziraat Participation, Vakıf Participation and DIBT are the investors of the Fund. As of 2024 October, the fund invested in 2 companies.",
        "sectoralPreferences": "12",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 154 M",
        "ticketSize": "₺ 25 M - 75 M ",
        "investmentStrategyText": "Seed, Series A, Series B",
        "website": "https://www.Türkiyekalkinmafonu.com.tr/en/our-funds/development-participation-venture-capital-investment-fund",
        "contactUs": "Türkiye Development Fund",
        "contactUsEmail": "info-tkf@kalkinma.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "Innovative and Advanced Technologies Fund",
        "mainInstitution": "Türkiye Development Fund",
        "foundedYear": 2021,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in technology companies operating in both defence and civilian sectors.",
        "details": "Innovative and Advanced Technologies Participation Venture Capital Investment Fund makes equity investments in tech-oriented companies with dual-use products and services. As of October 2024, the Fund invested in 2 companies. The Fund's investors include pioneering defense industry companies.",
        "sectoralPreferences": "9,11",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺ 340 M ",
        "ticketSize": "$ 250 K - 1 M",
        "investmentStrategyText": "Seed, Series A and above",
        "website": "https://www.Türkiyekalkinmafonu.com.tr/en/our-funds/innovative-and-advanced-technologies-venture-capital-investment-fund",
        "contactUs": "Türkiye Development Fund",
        "contactUsEmail": "info-tkf@kalkinma.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            4
        ],
        "logo":"/images/logos/yuksek-teknoloji-fonu.jpg"
    },
    {
        "ventureCapitalFund": "Technology and Innovation Fund",
        "mainInstitution": "Türkiye Development Fund",
        "foundedYear": 2020,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in tech-oriented start-ups with a high growth potential.",
        "details": "Technology and Innovation Fund supports both venture capital funds in the ecosystem through commitments and technology-focused start-ups with a high growth potential through direct investments. The investors of the Fund are Republic of Türkiye Ministry of Industry and Technology and KOSGEB. As of October 2024, the Fund invested in 9 companies and 3 funds.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺475 M ",
        "ticketSize": "$250K-1 M ",
        "investmentStrategyText": "Seed, Series A, Fund of Funds",
        "website": "https://www.Türkiyekalkinmafonu.com.tr/en/our-funds/technology-and-innovation-fund",
        "contactUs": "Türkiye Development Fund",
        "contactUsEmail": "info-tkf@kalkinma.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "DIBT Capital Fund",
        "mainInstitution": "Türkiye Development Fund",
        "foundedYear": 2021,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in high-growth, technology-oriented startups across diverse sectors, through commitments to venture capital funds within the ecosystem and co-investments.",
        "details": "DIBT Capital Fund supports both venture capital funds in the ecosystem through commitments and technology-focused start-ups with fintech, sustainability and a high growth potential through direct investments. The sole investor of the Fund is Development and Investment Bank of Türkiye. As of October 2024, the Fund invested in 3 companies and 5 VC funds.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺430 M",
        "ticketSize": "$ 250 K- 1 M",
        "investmentStrategyText": "Seed, Series A, Fund of Funds",
        "website": "https://www.Türkiyekalkinmafonu.com.tr/en/our-funds/development-and-investment-bank-of-t%C3%BCrkiye-capital-fund",
        "contactUs": "Türkiye Development Fund",
        "contactUsEmail": "info-tkf@kalkinma.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "DIBT Fund of Funds",
        "mainInstitution": "Türkiye Development Fund",
        "foundedYear": 2024,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A fund of funds was established to support and enhance the ecosystem.",
        "details": "Commitments will be made to funds that will invest in all technology and/or growth-oriented start-ups and businesses that will benefit Türkiye's development.",
        "sectoralPreferences": "1",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$50 M",
        "ticketSize": "$ 1-5 M",
        "investmentStrategyText": "Fund of Funds",
        "website": "https://www.Türkiyekalkinmafonu.com.tr/en/our-funds/dibt-fund-of-funds",
        "contactUs": "Türkiye Development Fund",
        "contactUsEmail": "UstFon.TKF@kalkinma.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":""
    },
    {
        "ventureCapitalFund": "TÜBİTAK BiGG Fund",
        "mainInstitution": "Türkiye Development Fund",
        "foundedYear": 2023,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in venture companies in collaboration with TÜBİTAK to support Türkiye's technological development and value-added growth strategy.",
        "details": "Established under the umbrella of Türkiye Development Fund in order to contribute to Türkiye's technological development and value-added growth strategy, the Fund invests in start-ups with the potential to generate growth and added value established to realise business plans that have received the seal of excellence under the TÜBİTAK 1812 programme.",
        "sectoralPreferences": "0",
        "geographicalPreferences": "Türkiye",
        "fundSize": "$8 M",
        "ticketSize": "₺900 K",
        "investmentStrategyText": "Pre-Seed",
        "website": "https://www.Türkiyekalkinmafonu.com.tr/en/our-funds/tubitak-bigg-fund",
        "contactUs": "Türkiye Development Fund",
        "contactUsEmail": "tubitakbigg@kalkinma.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 3,
        "investmentStrategy": [
            1
        ],
        "logo":""
    },
    {
        "ventureCapitalFund": "Vestel Ventures ",
        "mainInstitution": "Vestel Ventures",
        "foundedYear": 2015,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in early-stage deep-tech companies with strategic collaboration potential, aligning with the sectors in which Zorlu Conglomerate, Vestel, and the group companies operate, aiming to deliver added value and benefits to the parent organization.",
        "details": "Vestel Ventures was established in 2015 as a corporate venture capital (CVC). It operates with an evergreen fund structure, meaning it does not have a fixed fund size. Up until November 2024, it has invested in 28 startups across various sectors, located not only in Türkiye but also in countries like France, the UK, and the USA. A common trait among all these startups is their focus on technology development within their respective fields. \nVestel Ventures has made investments in diverse areas such as energy, nullomaterials, cybersecurity, artificial intelligence, mobility, smart city solutions, and automotive technologies. Additionally, it manages Parlak Bi’ Fikir, Zorlu Holding's intrepreneurship program, which has led to investments in five startups.\nIn 2022, Vestel Ventures partnered with Tacirler Portfolio Management to establish the Gelecek Etki Fonu (Future Impact Fund), a venture capital investment fund.\n",
        "sectoralPreferences": "1,22,11,18,14,12",
        "geographicalPreferences": "Türkiye, Global",
        "fundSize": "Evergreen",
        "ticketSize": "$500 K-1 M ",
        "investmentStrategyText": "Pre-seed, Seed, Series A",
        "website": "https://www.vestelventures.com ",
        "contactUs": "Nazlı Şakar\nNisa Akgün",
        "contactUsEmail": "efsernazli.sakar@vestel.com.tr\n\nayse.akgun@vestel.com.tr",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 2,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/vestel-venterus.jpg"
    },
    {
        "ventureCapitalFund": "Gozde Private Equity",
        "mainInstitution": "Yıldız Ventures",
        "foundedYear": 2010,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A publicly traded venture capital investment trust (VCIT) established to invest in startup companies and projects with high development potential, providing resources and restructuring support.",
        "details": "Gözde aims to invest in companies and projects that require finullcial and operational restructuring and offer the potential for quick and high returns. It leverages Yıldız Holding's strategic advantages, accumulated expertise, and specialized resources developed over the years. In addition to Gözde GSYO's private equity strategy, it invests globally in innovative early-stage startups through Gözde Tech Ventures. The fund also diversifies its portfolio by investing in other technology-focused VC funds. \nGözde Tech Ventures, the new generation technology investment arm of Gözde Private Equity, participates in early-stage to Series A+ funding rounds of companies that have demonstrated product-market fit, scalable technology, and growth potential. The focus areas include retail, industrial products, FMCG, wholesale, packaging, tech investments, and VC fund investments. The ticket sizes are typically $25 million to $150 million+ for private equity investments and $500,000 to $2 million for tech-focused VC funds and direct investments in startups.",
        "sectoralPreferences": "0,23,12,1",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺28.5 B",
        "ticketSize": "$500K-150 M",
        "investmentStrategyText": "All stages",
        "website": "https://www.gozdegirisim.com.tr/en",
        "contactUs": "Serkan Yandı, Ecem Altiok",
        "contactUsEmail": "mali.isler@gozdegirisim.com.tr\nfund@yildiz.ventures",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": 2,
        "investmentStrategy": [],
        "logo":"/images/logos/gozde-tech-venterus.jpg"
    },
    {
        "ventureCapitalFund": "Yıldız Ventures VCIF",
        "mainInstitution": "Yıldız Ventures",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund which is founded and managed by Yıldız Holding, aiming to invest in companies with growth and value-added potential that promise high returns, supporting them to scale using the holding’s resources",
        "details": "Founded and managed by Yıldız Holding, VCIF aims to invest in companies with growth and value-added potential that promise high returns, supporting them to scale using the holding’s resources. Additionally, it focuses on companies that can be integrated into Yıldız Holding’s core business areas, such as food and retail. In addition to finullcial support, the fund provides operational and strategic support to startups in areas such as management, planning, marketing, technology, and human resources",
        "sectoralPreferences": "1,11,8,23,6,7,4",
        "geographicalPreferences": "Türkiye",
        "fundSize": "₺200 M",
        "ticketSize": null,
        "investmentStrategyText": "Seed, Series A, Series B",
        "website": "https://www.kap.org.tr/en/fon-bilgileri/ozet/4028328c84686b400184c28045a35db6",
        "contactUs": "Ecem Altıok",
        "contactUsEmail": "fund@yildiz.ventures",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [
            2,
            3
        ],
        "logo":"/images/logos/yildiz-venterus.jpg"
    },
    {
        "ventureCapitalFund": "Gozde Tech Ventures",
        "mainInstitution": "Yıldız Ventures",
        "foundedYear": 2022,
        "city": "İstanbul",
        "hq": "Türkiye",
        "summary": "A VC fund that invests in innovative startups with high-growth potential and demonstrated traction, focusing on those with proprietary technology, agility, and the capacity to explore new business models and opportunities driving global technological transformation.",
        "details": "Established in 2022, Gözde Tech Ventures is the new generation technology investment arm of Gözde Private Equity aiming to escalate Gözde Private Equity’s exposure to technology investments in Türkiye and abroad. The fund focuses on innovative startups with high-growth potential, proven traction, and proprietary technology. Gözde Tech Ventures invests in companies that demonstrate agility and the ability to explore new business models and opportunities, contributing to the global technological transformation.",
        "sectoralPreferences": "8,23,6,7,1,11,4",
        "geographicalPreferences": "Türkiye, Global ",
        "fundSize": "$2 M",
        "ticketSize": "$500K -2M ",
        "investmentStrategyText": "Seed - Series A+",
        "website": "https://gozde.ventures/en/",
        "contactUs": "Ecem Altıok",
        "contactUsEmail": "fund@yildiz.ventures",
        "isBasedInTurkey": true,
        "isPublicInstitution": false,
        "mainCategory": null,
        "investmentStrategy": [],
        "logo":"/images/logos/gozde-tech-venterus.jpg"
    }
]